import axios from "axios";
import api from "../utils/api";
const state = {
  token: window.localStorage.userToken || ""
};

const getters = {
  getToken(state) {
    return state.token;
  },
  isLogin(state) {
    return !!state.token && state.token !== "";
  }
};

const actions = {
  setToken({ commit }, { token }) {
    return new Promise(resolve => {
      resolve(commit("setToken", { token }));
    });
  },

  removeToken({ commit }) {
    commit("setToken", { token: "" });
  },

  logout(store) {
    return api.post("/logout").then(() => {
      store.dispatch("removeToken");
      window.location.replace(`${api.authUrl}/api/logout`);
    });
  }
};

const mutations = {
  setToken(state, { token }) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.userToken = token;
    state.token = token;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
